<div class="edit-section" [ngClass]="{'edit-section-delete': selectedRecord&&selectedRecord[toDeleteCol], 'edit-section-disabled': disableEditing}">
	<div class="operation-section">
		<div class="card-button-group">
			<button class="button-general" [disabled]="!currentList.length" (click)="discard()">Discard</button>
			<button class="button-general" [title]="commitDisableReason" [disabled]="checkCommitDisabled()" (click)="commit()">Commit</button>
		</div>
	</div>
	<div class="edit-top">
		<div class="edit-control-wrap">
			<div *ngIf="selectedRecord" class="edit-control" [ngClass]="{'first-record': currentList.indexOf(selectedRecord)===0, 'last-record':currentList.indexOf(selectedRecord)===currentList.length-1}">
				<div class="go-prev">
					<i class="glyphicons glyphicons-chevron-left" (click)="goPrevRecord()"></i>
				</div>
				<div class="card-index">
					{{currentList.indexOf(selectedRecord) + 1}} / {{currentList.length}}
				</div>
				<div class="go-next">
					<i class="glyphicons glyphicons-chevron-right" (click)="goNextRecord()"></i>
				</div>
			</div>
			<div *ngIf="editedListLength" class="slide-switch">
				<label>Selected ({{selectionListLength}})</label>
					<mat-slide-toggle
						class="unbiased-slide-toggle"
						[(ngModel)]="isEditedListCurrent"
						(change)="changeDisplayMode()">
					</mat-slide-toggle>
				<label>Edited ({{editedListLength}})</label>
			</div>
		</div>
	</div>
	<div *ngIf="selectedRecord" class="edit-content" [ngClass]="{'delete-record': selectedRecord[toDeleteCol], 'edited-record': selectedRecord[this.isEditedCol]}">
		<div class="edit-row-group">
			<ng-container *ngFor="let col of columns;let idx = index;">
				<div *ngIf="col.isDisplay!==false && !col.info.hideFromEditing" class="edit-row">
					<div class="edit-column" appHtmlTooltip [tooltip]="col.info.tooltip">{{col.name}}</div>
					<div class="edit-value" title="{{selectedRecord[col.prop]}}" [ngClass]="{'field-dirty': checkFieldDirty(col)}">
						<input *ngIf="!domainsByColumn[col.prop] || domainsByColumn[col.prop].type !== 'list'"
							name="{{col.prop}}-{{idx}}"
							[disabled]="col.info.isEditDisabled || selectedRecord[toDeleteCol] || disableEditing"
							pattern="{{domainsByColumn[col.prop] ? domainsByColumn[col.prop].pattern : ''}}"
							appValidateRange="{{domainsByColumn[col.prop] ? domainsByColumn[col.prop].range : null}}"
							[(ngModel)]="selectedRecord[col.prop]"
							(ngModelChange)="onChange(col)"
						>

						<ng-container *ngIf="domainsByColumn[col.prop] && domainsByColumn[col.prop].type==='list'">
							<select *ngIf="col.info.standardColName!=='County'&&col.info.standardColName!=='State'"
								name="{{col.prop}}-{{idx}}"
								[disabled]="col.info.isEditDisabled || selectedRecord[toDeleteCol] || disableEditing"
								[ngClass]="{
										'invalid-select': selectedRecord[col.prop] && domainsByColumn[col.prop].list?.indexOf(selectedRecord[col.prop]) < 0
									}"
								[(ngModel)]="selectedRecord[col.prop]" (ngModelChange)="onChange(col)">
								<ng-container *ngIf="selectedRecord[col.prop] && domainsByColumn[col.prop].list?.indexOf(selectedRecord[col.prop]) < 0">
									<option disabled>{{selectedRecord[col.prop]}}</option>
								</ng-container>
								<option *ngFor="let val of domainsByColumn[col.prop].list" [ngValue]="val">{{val}}</option>
								<option [ngValue]="null">Null</option>
							</select>
							<select #S *ngIf="col.info.standardColName===countyColStandard||col.info.standardColName===stateColStandard"
								name="{{col.prop}}-{{idx}}"
								[disabled]="col.info.isEditDisabled || selectedRecord[toDeleteCol] || disableEditing"
								[ngClass]="{'invalid-select': !checkValueInDomain(col)}"
								[ngModel]="selectedRecord[col.prop]" (ngModelChange)="onChangeStateOrCounty(col, $event, S)">
								<ng-container *ngIf="!col.info.neighborList">
									<option *ngFor="let val of domainsByColumn[col.prop].list" [ngValue]="val">{{val}}</option>
									<option [ngValue]="neighborOption">&lt; Neighbors &gt;</option>
								</ng-container>
								<ng-container *ngIf="col.info.neighborList">
									<option *ngFor="let val of col.info.neighborList" [ngValue]="val">{{val}}</option>
								</ng-container>
							</select>
						</ng-container>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>